import React from 'react';
import PropTypes from 'prop-types';

export default class Person extends React.Component {

  static propTypes = {
    email: PropTypes.string,
    onEmailChange: PropTypes.func
  }

  render() {
    return (
      <div className='row person'>
        <div className='col-sm-12'>
          <form>
            <label htmlFor='email'>Email</label>
            <input className='input-text lowercase' id='email' type="email" name="email" autoComplete='on' autoFocus onChange={event => this.props.onEmailChange(event)}></input>
          </form>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/person.jsx